<template>
  <div v-if="privacyPageUuid" v-html="page.content"></div>
  <div v-else>
    <h3>Na czym nam zależy?</h3>
    <p>Dokument Polityka Prywatności jest wyrazem dbałości o prawa osób korzystających z niniejszego serwisu
      zapewniającego dostęp
      do konta w programie lojalnościowym <span v-encode="title"></span> organizowanym przez <span
          v-encode="adminName"></span>.</p>
    <p>Jednocześnie dokument spełnia obowiązek informacyjny wynikający z art. 13 Rozporządzenia
      Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r. w sprawie
      ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego
      przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie
      danych osobowych) (Dz. Urz. UE L119 z 4.05.2016, str. 1) (dalej RODO).</p>
    <p>Mamy nadzieję, że w niniejszej Polityce Prywatności znajdziesz odpowiedzi na wszystkie
      pytania dotyczące ochrony Twoich danych osobowych. W przypadku jakichkolwiek dodatkowych
      wątpliwości, zawsze możesz się z nami skontaktować pisząc na adres korespondencyjny {{ contactEmail }}
      lub odwiedzając jedną z naszych fizycznych placówek.</p>
    <h3>Kto jest administratorem Twoich danych?</h3>
    <p><strong> </strong>Administratorem Twoich danych osobowych jest <span v-encode="adminName"></span>.</p>
    <h3 v-if="entity.iodoEmail">Jak skontaktować się z naszym Inspektorem Ochrony Danych
      Osobowych?</h3>
    <p v-if="entity.iodoEmail">W naszej firmie powołaliśmy Inspektora Ochrony Danych Osobowych, z
      którym możesz się
      skontaktować się we wszystkich sprawach dotyczących przetwarzania danych osobowych wysyłając
      wiadomość e-mail na adres: {{ entity.iodoEmail }}.</p>
    <h3>Jak pozyskujemy Twoje dane?</h3>
    <p>Twoje dane osobowe pozyskujemy, gdy rejestrujesz się w naszym programie lojalnościowym.
    </p>
    <h3>Jaka jest podstawa, cel i zakres?</h3>
    <p>Przetwarzamy Twoje dane osobowe w zakresie zależnym od celów ich przetwarzania, co z kolei
      determinuje podstawę prawną legitymizującą ich przetwarzanie.</p>
    <p><strong>Realizacja programu lojalnościowego</strong></p>
    <p><em>Kategorie danych<br/> </em>Dane, które zbieramy w tym celu to Twoje dane
      identyfikacyjne (imię i nazwisko, nazwa firmy), kontaktowe (adres e-mail, telefon), adresowe, data
      urodzenia oraz płeć.</p>
    <p><em>Podstawa prawna<br/> </em>art. 6 ust. 1 lit. b) RODO – niezbędność do podjęcia działań
      na Twoje żądanie przed zawarciem umowy oraz do wykonania umowy.</p>
    <p><strong>Komunikacja (odpowiedzi na pytania, skargi i wnioski)</strong></p>
    <p><em>Kategorie danych<br/> </em>Twoje dane identyfikacyjne i kontaktowe, dane o korzystaniu
      przez Ciebie z naszych produktów i usług, dane dotyczącej
      Twojej aktywności w programie lojalnościowym, dane będące przedmiotem Twoich zapytań, skarg czy
      wniosków.
    </p>
    <p><em>Podstawa prawna</em><br/>art. 6 ust. 1 lit. f) RODO – nasz prawnie uzasadniony interes w zakresie
      pozostawania z Tobą w kontakcie i
      udzielania pomocy/odpowiedzi na Twoje pytania.</p>
    <p><strong>Marketing</strong></p>
    <p><em>Kategorie danych<br/> </em>Twoje dane identyfikacyjne i kontaktowe, dane dotyczącej
      Twojej aktywności w programie lojalnościowym.</p>
    <p><em>Podstawa prawna<br/> </em>art. 6 ust. 1 lit. a) zgoda na przetwarzanie danych
      osobowych. Podanie danych jest dobrowolne, lecz niezbędne do realizacji umowy.</p>
    <h3>Jak długo przechowujemy Twoje dane?</h3>
    <p>
      <strong>Realizacja programu lojalnościowego</strong><br>
      Do czasu rezygnacji z udziału w programie lojalnościowym (z zastrzeżeniem czasu niezbędnego do ustalenia,
      dochodzenia lub obrony roszczeń) lub do czasu utraty przydatności tych danych.
    </p>
    <p>
      <strong>Komunikacja (odpowiedzi napytania, skargi i wnioski)</strong><br>
      Przez czas niezbędny do ustalenia, dochodzenia lub obrony roszczeń.
    </p>
    <p>
      <strong>Marketing</strong><br>
      Do czasu cofnięcia zgody lub utraty przydatności tych danych.
    </p>
    <p v-if="showCookiesInfo">
      <strong>Pliki "cookies"</strong><br>
      Do czasu zmiany preferencji w ustawieniach lub utraty przydatności tych danych.
    </p>
    <h3>Jakie posiadasz uprawnienia jako Podmiot Danych Osobowych?</h3>
    <p>Zgodnie z art. 7, 15 – 22 oraz 77 RODO każdemu użytkownikowi przysługują następujące
      prawa:</p>
    <p><strong>Prawo dostępu do danych (art. 15 RODO)<br/> </strong>Osoba, której dane dotyczą,
      jest uprawniona do uzyskania od administratora potwierdzenia, czy przetwarzane są dane
      osobowe jej dotyczące, a jeżeli ma to miejsce, jest uprawniona do uzyskania dostępu do nich.
      Zgodnie z art. 15 administrator dostarczy osobie, której dane dotyczą, kopię danych
      osobowych podlegających przetwarzaniu.</p>
    <p><strong>Prawo do sprostowania danych (art. 16 RODO)<br/> </strong>Osoba, której dane
      dotyczą, ma prawo żądania od administratora niezwłocznego sprostowania dotyczących jej
      danych osobowych, które są nieprawidłowe.</p>
    <p><strong>Prawo do usunięcia danych („prawo do bycia zapomnianym&#8221;) (art. 17 RODO)<br/>
    </strong>Osoba, której dane dotyczą, ma prawo żądania od administratora niezwłocznego
      usunięcia dotyczących jej danych osobowych, a administrator ma obowiązek bez zbędnej zwłoki
      usunąć dane osobowe, jeżeli zachodzi jedna z następujących okoliczności:</p>
    <ul>
      <li>dane osobowe nie są już niezbędne do celów, w których zostały zebrane lub w inny sposób
        przetwarzane,
      </li>
      <li>osoba, której dane dotyczą, cofnęła zgodę, na której opiera się przetwarzanie,</li>
      <li>osoba, której dane dotyczą, wnosi sprzeciw na mocy art. 21 ust. 1 wobec przetwarzania i
        nie występują nadrzędne prawnie uzasadnione podstawy przetwarzania.
      </li>
    </ul>
    <p><strong>Prawo do ograniczenia przetwarzania (art. 18 RODO)<br/> </strong>Osoba, której dane
      dotyczą, ma prawo żądania od administratora ograniczenia przetwarzania w następujących
      przypadkach:</p>
    <ul>
      <li>kiedy dane są nieprawidłowe &#8211; na czas do ich poprawy,</li>
      <li>osoba, której dane dotyczą, wniosła sprzeciw na mocy art. 21 ust. 1 wobec przetwarzania
        &#8211; do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie administratora
        są nadrzędne wobec podstaw sprzeciwu osoby, której dane dotyczą,
      </li>
      <li>przetwarzanie jest niezgodne z prawem, a osoba, której dane dotyczą, sprzeciwia się
        usunięciu danych osobowych, żądając w zamian ograniczenia ich wykorzystywania.
      </li>
    </ul>
    <p><strong>Prawo do przenoszenia danych (art. 19 RODO)<br/> </strong>Masz prawo otrzymać swoje
      dane osobowe, które nam dostarczyłeś, by następnie przesłać je innemu administratorowi
      danych osobowych. Możesz również zażądać, by dane osobowe zostały przesłane przez nas
      bezpośrednio innemu administratorowi, o ile jest to technicznie możliwe. Realizacja prawa do
      przenoszenia danych może doznać ograniczenia w przypadku, gdyby miała niekorzystnie wpłynąć
      na prawa i wolności innych osób.</p>
    <p><strong>Prawo do sprzeciwu wobec wykorzystania danych (art. 21 RODO)<br/> </strong>Masz
      prawo w dowolnym momencie wnieść sprzeciw wobec przetwarzania Twoich danych osobowych, w tym
      profilowania, gdy oparte jest ono na prawnie uzasadnionym interesie. W przypadku zasadności
      Twojego sprzeciwu i braku innej podstawy prawnej do przetwarzania Twoich danych osobowych,
      Twoje dane nie będą przez nas przetwarzane. W przypadku wniesienia przez Ciebie sprzeciwu
      wobec przetwarzania Twoich danych na potrzeby marketingu bezpośredniego, Twoje dane nie będą
      przetwarzane przez nas w tym celu.</p>
    <p><strong>Prawo do cofnięcia zgody (art. 7 RODO)<br/> </strong>Udzielanie jakiejkolwiek zgody
      na przetwarzanie danych osobowych przez nas jest dobrowolne i masz prawo w dowolnym momencie
      ją wycofać. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego IBSO
      dokonało na tej podstawie przed wycofaniem zgody.</p>
    <p><strong>Prawo do złożenia skargi do odpowiedniego Organu Nadzorczego (art. 77 RODO)<br/>
    </strong>Jeżeli uznasz, iż przetwarzanie Twoich danych osobowych narusza Twoje prawa, masz
      prawo wniesienia skargi do właściwego miejscowo Organu Nadzorczego, tj. Prezesa Urzędu
      Ochrony Danych Osobowych na adres ul. Stawki 2, Warszawa 00-193.</p>
    <h3>Jak skorzystać z przysługujących Ci praw?</h3>
    <p>Aby zrealizować którekolwiek z wyżej wymienionych praw, możesz skontaktować się z nami, pisząc na
      adres
      korespondencyjny {{ contactEmail }} lub odwiedzić jedną z naszych fizycznych placówek. </p>
    <p>Dodatkowo, prawa dostępu do danych oraz ich sprostowania możesz zrealizować za pomocą niniejszego
      serwisu.</p>
    <h3>Jak dbamy o bezpieczeństwo Twoich danych?</h3>
    <p>Dołożyliśmy wszelkich starań, aby zapewnić bezpieczeństwo powierzonych nam danych
      osobowych, zarówno na obszarze technicznym jak i organizacyjnym.</p>
    <h3>Komu udostępniamy Twoje dane?</h3>
    <p>Konieczne jest korzystanie przez nas z usług podmiotów zewnętrznych.
      Przy czym, korzystamy wyłącznie z usług takich podmiotów przetwarzających, którzy zapewniają
      wystarczające gwarancje wdrożenia
      odpowiednich środków technicznych i organizacyjnych, tak by przetwarzanie spełniało wymogi
      Rozporządzenia RODO i chroniło prawa osób,
      których dane dotyczą. Przekazujemy dane wyłącznie wtedy, gdy jest to niezbędne do realizacji danego
      celu przetwarzania danych osobowych
      i tylko w zakresie niezbędnym do jego zrealizowania. </p>
    <p>Odbiorcami Twoich danych są podmioty, które działają wyłącznie na nasze polecenie, świadczące usługi
      niezbędne do funkcjonowania naszej firmy, w tym programu lojalnościowego, którego jesteś
      uczestnikiem. </p>
    <p>Możemy również udostępnić Twoje dane w wypadku zgłoszenia żądania uprawnionych organów państwowych, w
      zakresie i na podstawie określonych przepisami prawa.</p>

    <h3>Czy mogą nastąpić zmiany w Polityce Prywatności?</h3>
    <p>Zastrzegamy sobie prawo zmiany niniejszej Polityce Prywatności, jednocześnie zobowiązujemy
      się do niezwłocznego poinformowania o zmianach drogą mailową naszych Klientów.</p>
    <h3 v-if="termsPageUuid">Czy istnieją inne wdrożone przez nas regulacje?</h3>
    <p v-if="termsPageUuid">Oprócz niniejszej Polityki Prywatności zasady przetwarzania danych osobowych
      zostały
      opisane w
      <a href="#" class="m-nav__link" @click="openTermsModal">
        <span class="m-nav__link-text ">Regulaminie</span>
      </a>
      .
    </p>
    <h3>Piki Cookies</h3>
    <div v-if="showCookiesInfo">
      <p>
        Podczas korzystania z niniejszego serwisu używane są pliki „cookies”, czyli niewielkie informacje tekstowe,
        które są zapisywane w Twoim urządzeniu końcowym.
      </p>

      <p v-if="isGoogleAnalyticsEnabled">
        W celach analitycznych korzystamy z narzędzia Google Analytics firmy Google LLC, 1600
        Amphitheatre Parkway, Mountain View, CA 94043, USA. Jeżeli jesteś zainteresowany szczegółami związanymi z
        przetwarzaniem danych w ramach Google Analytics, zachęcamy do zapoznania się z wyjaśnieniami przygotowanymi
        przez Google: <a href="https://support.google.com/analytics/answer/6004245" target="_blank">https://support.google.com/analytics/answer/6004245</a>.
      </p>

      <p v-if="isFbPixelEnabled">
        W celach marketingowych korzystamy z narzędzia Facebook Piksel firmy Facebook Inc., 1601 S.
        California Ave. Palo Alto, CA 94304, USA lub Facebook Ireland Ltd. 4 Grand Canal Square, Grand Canal Harbour,
        Dublin 2 Ireland. Dodatkowych informacji możesz szukać bezpośrednio w polityce prywatności Facebooka:
        <a href="https://www.facebook.com/privacy/explanation" target="_blank">https://www.facebook.com/privacy/explanation</a>.
      </p>

      <p>
        W każdej chwili możesz zablokować stosowanie plików "cookies", zmieniając Twoje preferencje dotyczące tych
        plików.
      </p>
    </div>
    <p v-else>Podczas korzystania z niniejszego serwisu nie są używane żadne pliki „cookies”.</p>
  </div>
</template>

<script>
import Encode from "@/directives/encode";
import {mapActions, mapState} from 'vuex'
import {PAGE} from "@/utils/PageModalTypes";

export default {
  name: "PrivacyPolicyContent",
  directives: {Encode},
  props: {
    termsInModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: {
        content: null,
      }
    };
  },
  mounted() {
    if (this.privacyPageUuid) {
      this.getPage('privacy/' + this.entityUuid);
    }
  },
  methods: {
    ...mapActions([
      'setPageModal'
    ]),
    openTermsModal() {
      if (this.termsInModal) {
        this.setPageModal({
          show: true,
          type: PAGE,
          title: 'Regulamin',
          content: 'terms/' + this.entityUuid
        });
      } else {
        this.$router.push({name: 'CustomPage', params: {pageUuid: 'terms'}})
      }
    },
    getPage(uuid) {
      this.$http.get('/page/' + uuid)
          .then((r) => {
            this.page = r.data.page
          })
    }
  },
  computed: {
    ...mapState({
      entityUuid: state => state.auth.entity.uuid,
      entity: state => state.settings.entity,
      title: state => state.settings.title,
      termsPageUuid: state => state.settings.termsPageUuid,
      contactEmail: state => state.settings.contactEmail,
      privacyPageUuid: state => state.settings.privacyPageUuid,
      analytics: state => state.settings.analytics,
    }),
    adminName() {
      let name;

      if (this.entity.billingData.companyName !== null)
        name = this.entity.billingData.companyName;
      else
        name = this.entity.billingData.firstName + ' ' + this.entity.billingData.lastName;

      if (this.entity.billingData.street !== null)
        name += ', ul. ' + this.entity.billingData.street;

      if (this.entity.billingData.postCode !== null || this.entity.billingData.city !== null)
        name += ', ' + this.entity.billingData.postCode + ' ' + this.entity.billingData.city;

      if (this.entity.billingData.nip !== null)
        name += ', NIP: ' + this.entity.billingData.nip;

      return name;
    },
    showCookiesInfo() {
      return this.isGoogleAnalyticsEnabled || this.isFbPixelEnabled;
    },
    isGoogleAnalyticsEnabled() {
      return this.analytics.ua || this.analytics.ga4;
    },
    isFbPixelEnabled() {
      return this.analytics.fbp;
    }
  }
}
</script>

<style scoped>

</style>
